"use client";
import React from "react";

const IntegrationsSection = () => {
  const integrations = [
    "Workday",
    "SAP SuccessFactors",
    "Oracle HCM",
    "Greenhouse",
    "Lever",
    "iCIMS",
    "Bullhorn",
    "Merge"
  ];

  return (
    <section className="relative py-24 bg-[#F3F1FA]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div>
            <p className="text-accent text-sm font-semibold uppercase tracking-wider mb-4">
              Enterprise Ready
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-jacarta-700 mb-6">
              Integrates with your{" "}
              <span className="text-accent">
                existing stack
              </span>
            </h2>
            <p className="text-jacarta-500 text-lg mb-8 leading-relaxed">
              SynthiaHire fits seamlessly into your HR tech ecosystem. Our developer-friendly APIs integrate with any ATS, CRM, or HRMS in hours—not days.
            </p>

            {/* Features list */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-green/20 flex items-center justify-center">
                  <svg className="w-3.5 h-3.5 text-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-jacarta-600">2-way sync with your ATS</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-green/20 flex items-center justify-center">
                  <svg className="w-3.5 h-3.5 text-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-jacarta-600">Single-page API documentation</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full bg-green/20 flex items-center justify-center">
                  <svg className="w-3.5 h-3.5 text-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-jacarta-600">Enterprise-grade security</span>
              </div>
            </div>
          </div>

          {/* Right content - Integration logos */}
          <div className="relative">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-accent/5 rounded-3xl blur-[60px]" />
            
            <div className="relative p-8 rounded-2xl bg-white border border-accent/10 shadow-lg shadow-accent/5">
              <div className="grid grid-cols-4 gap-4">
                {integrations.map((integration, index) => (
                  <div 
                    key={index}
                    className="aspect-square rounded-xl bg-[#F3F1FA] border border-accent/10 flex items-center justify-center p-4 hover:border-accent/30 hover:bg-accent/5 transition-all duration-300"
                  >
                    <span className="text-jacarta-600 text-xs text-center font-medium">
                      {integration}
                    </span>
                  </div>
                ))}
              </div>
              
              <p className="mt-6 text-center text-jacarta-500 text-sm">
                + Many more through Merge integration
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
